import { Component, HostListener, ChangeDetectionStrategy } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService, SnackBarService, StateService } from 'src/app/services';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ForgotPasswordComponent {

  public email: string = null;
  public emailRegexp: RegExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/gm;
  public forgotPasswordFormSubmited: boolean = false;
  public lang: string = null;

  constructor(private router: Router, private authService: AuthService,
    private stateService: StateService,
    private snackBarService: SnackBarService) { }

  // Validation errors
  public emailNotValid: boolean = false;

  @HostListener('document:keyup.enter', ['$event']) onKeyUpHandler(event: KeyboardEvent) {
    event.preventDefault();
    this.submitForgotPassword();
  }

  public cancel(e): void {
    e.preventDefault();
    this.router.navigate(["/login"]);
  }

  public goToZilex() {
    window.open('https://zilex.de', '_blank');
  }
  public vmOnLanguageChange(value: string) {
    this.lang = this.stateService.restore('deviceLang');
  };
  public submitForgotPassword(e?): void {
    if (e) {
      e.preventDefault();
    };

    this.emailNotValid = false;

    // If email not entered or not valid 
    // Show error message
    if (!this.email || !this.email.match(this.emailRegexp)) {
      this.emailNotValid = true;
      return;
    }

    this.authService.forgotPassword(this.email).subscribe({
      next: () => {
        this.forgotPasswordFormSubmited = true;
      },
      error: (error) => {
        this.snackBarService.open();
      }
    })
  }
};